import {
    GET_CURRENT_TESTIMONIALS
} from './constants';

const initialState = {
    currentTestimonials: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CURRENT_TESTIMONIALS: {
            return {
                ...state,
                currentTestimonials: action.payload,
            };
        }
        default:
            return state;
    }
};

